import { useMemo } from "react";
import { useMapLayer } from "../hooks/useMapLayer";
import PointObject from "../objects/PointObject";
import type { MapLayerProps, PointMapObject } from "../types";

type PointsLayerProps = Pick<MapLayerProps<PointMapObject>, "id" | "items">;

const PointsLayer = ({ id, items }: PointsLayerProps) => {
    const { items: layerItems } = useMapLayer({ items });
    const pointObjects = useMemo(
        () =>
            layerItems.map((item) => <PointObject key={item.id} item={item} />),
        [layerItems],
    );

    return (
        <pixiContainer label={`points-layer-${id}`}>
            {pointObjects}
        </pixiContainer>
    );
};

export default PointsLayer;
